import { Route } from '@angular/router';
import { EnrollComponent } from './components/enroll/enroll.component';
import { NotifyLinkComponent } from './components/notify-link/notify-link.component';
import { ClubeSubscriberCheckerComponent } from './components/clube-subscriber-checker/clube-subscriber-checker.component';
import { IfoodLandingComponent } from './components/ifood-landing/ifood-landing.component';

export const appRoutes: Route[] = [
  {
    path: ':partner/start-link/:token',
    component: EnrollComponent,
    data: { action: 'start-link' },
  },
  {
    path: ':partner/resume-link/:token',
    component: EnrollComponent,
    data: { action: 'resume-link' },
  },
  {
    path: ':partner/notify-link/:token',
    component: NotifyLinkComponent,
  },
  {
    path: ':partner/club-subscriber-checker',
    component: ClubeSubscriberCheckerComponent,
  },
  {
    path: ':partner/landing',
    component: IfoodLandingComponent,
  },
  {
    path: 'promotion-suggestions/:id',
    loadComponent: () =>
      import(
        './components/promotion-suggestions-landing/promotion-suggestions-landing.component'
      ).then((m) => m.PromotionSuggestionsLandingComponent),
  },
];
